import { IClientData, IClientForm } from '../models';

export function mapClientForm(clientDetails: IClientData): IClientForm {
	const {
		id,
		partnerId,
		shortName,
		formalName,
		domainName,
		color,
		website,
		contractDto,
		clientUserCountLimit,
		limitPerClientId,
		surveyCountLimit,
		comment,
		mailListKey,
		logo: { publicUrl },
		hasOngoingSurveys,
		hasPlannedSurveys,
	} = clientDetails;

	return {
		id,
		partnerId,
		shortName,
		formalName,
		domainName,
		color,
		website,
		clientUserCountLimit,
		limitPerClientId,
		surveyCountLimit,
		comment,
		logo: publicUrl,
		mailingListKey: mailListKey,
		contract: contractDto?.fileKey,
		contractStartDate: contractDto?.startDate,
		contractEndDate: contractDto?.endDate,
		hasOngoingSurveys,
		hasPlannedSurveys,
	};
}
